module.exports = __webpack_public_path__ + "static/img/chrome.65d061d2.png";